import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b0662c6e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b0662c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0662c6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0662c6e')) {
      api.createRecord('b0662c6e', component.options)
    } else {
      api.reload('b0662c6e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b0662c6e&scoped=true&", function () {
      api.rerender('b0662c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JTVJsAeTZvJP/JS/comp/DocBox.vue"
export default component.exports